export enum CHECKOUTFORM_VALIDATION_EXCLUDE_FIELD_TYPES {
    FIRSTNAME = 'FirstName',
    LASTNAME = 'LastName',
    EMAIL = 'Email',
    PASSWORD = 'Password',
    COUNTRYCODE = 'CountryCode',
    STATECODE = 'StateCode',
}
